import { render, staticRenderFns } from "./savePop.vue?vue&type=template&id=076b1960&scoped=true"
import script from "./savePop.vue?vue&type=script&lang=js"
export * from "./savePop.vue?vue&type=script&lang=js"
import style0 from "./savePop.vue?vue&type=style&index=0&id=076b1960&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b1960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076b1960')) {
      api.createRecord('076b1960', component.options)
    } else {
      api.reload('076b1960', component.options)
    }
    module.hot.accept("./savePop.vue?vue&type=template&id=076b1960&scoped=true", function () {
      api.rerender('076b1960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/toNextYear/savePop.vue"
export default component.exports